import { ModuleWithProviders, NgModule } from '@angular/core';
import { INDEXED_DB_CONFIG_TOKEN, IndexedDbConfig } from '@shared/indexed-db/constants/indexed-db.const';

@NgModule({})
export class IndexedDbModule {
  public static forRoot(config: IndexedDbConfig): ModuleWithProviders<IndexedDbModule> {
    return {
      ngModule: IndexedDbModule,
      providers: [{ provide: INDEXED_DB_CONFIG_TOKEN, useValue: config }],
    };
  }
}
